import React from "react";
import { MessengerService, PluginWrapper } from "@vlogr/plugin-sdk";
//import { Main } from "@vlogrinc/vlogr.google-photos-react-components-lib";
import { Main } from './google-photos-react-components-lib';
import axios from "axios";

interface IItem {
  type: string;
  file: string;
  size: string;
}

function App() {
  const messengerService = new MessengerService(window as unknown as Window);

  const create = (data: IItem[]) => {
    messengerService.create(data, (data: any): void => {
      // do nothing
    });
  };

  const componentCallback = (data: any): void => {

    const elements = [];
    elements.push({
      type: data.type,
      file: data.file || data.mp4,
      size: data.fileSize,
      thumbnail: data.thumbnail
    });

    create(elements);
  };

  return (
    <PluginWrapper messenger={messengerService}>
      <Main axios={axios} getPhotosData={componentCallback} />
    </PluginWrapper>
  );
}

export default App;
